import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import {
  ExportButton as AdminExportButton,
  ExportButtonProps as AdminExportButtonProps,
} from 'react-admin';

export type ExportButtonProps = AdminExportButtonProps;

export function ExportButton({
  variant = 'outlined',
  size = 'medium',
  label,
  ...restProps
}: ExportButtonProps): JSX.Element {
  const translate = useTypedTranslate();

  return (
    <AdminExportButton
      label={label ?? translate('app.buttons.export')}
      size={size}
      variant={variant}
      {...restProps}
    />
  );
}
